import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Chip,
  TextField,
  InputAdornment,
} from "@material-ui/core";
import { useState } from "react";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import SearchInputDebounced from "./SearchInputDebounced";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { FETCH_COMPANIES } from "../graphql/queries";
import { useQuery } from "@apollo/client";

export default function SelectFilterModalCompany({
  onChange,
  loading,
  title,
  required,
  error,
  fullWidth,
  style,
  margin,
  errorLabel,
  value,
  companyState,
}) {
  const [newValueCompany, setNewValueCompany] = useState(companyState || []);
  const [showDialog, setShowDialog] = useState(false);

  const { data } = useQuery(FETCH_COMPANIES);

  // // Search
  const [searchTerm, setSearchTerm] = useState(null);

  const handleChangeCheckbox = (e) => {
    const value = parseInt(e.target.value);
    let index = newValueCompany.findIndex((id) => id === value);

    if (index >= 0 && e.target.checked === false) {
      deleteItem(index);
    } else {
      let clone = [...newValueCompany];
      clone.push(value);
      setNewValueCompany(clone);
    }
  };

  const deleteItem = (index) => {
    let clone = [...newValueCompany];
    clone.splice(index, 1);
    setNewValueCompany(clone);
  };

  const handleSelect = () => {
    onChange(newValueCompany);
    setShowDialog(false);
  };

  const handleClearFilter = () => {
    onChange(value);
    setNewValueCompany([]);
    setSearchTerm(null);
    setShowDialog(false);
  };

  return (
    <>
      <TextField
        style={style}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <ArrowDropDownIcon
                style={{ color: "#787878", marginRight: -6 }}
              />
            </InputAdornment>
          ),
        }}
        InputLabelProps={{
          shrink: newValueCompany.length > 0,
        }}
        onClick={() => {
          setShowDialog(true);
        }}
        variant="outlined"
        fullWidth={fullWidth}
        required={required}
        value={newValueCompany
          .map(
            (companyId) =>
              data?.fetchCompanies.data.find((company) => company.id === companyId)?.name
          )
          .join(", ")}
        label={title}
        margin={margin}
        error={error}
        helperText={errorLabel}
      />

      <Dialog
        open={showDialog}
        onClose={() => setShowDialog(false)}
        maxWidth="md"
      >
        <DialogTitle>{"Empresa"}</DialogTitle>
        <DialogContent>
          <SearchInputDebounced
            typeSearch="inDialog"
            onChange={(value) => {
              setSearchTerm(value);
            }}
          />

          <div style={{ marginTop: 20, width: 300 }}>
            {newValueCompany.map((companyId, index) => {
              const companyName = data?.fetchCompanies.data.find(
                (company) => company.id === companyId
              )?.name;
              return (
                <Chip
                  label={companyName}
                  onDelete={() => deleteItem(index)}
                  key={companyId}
                />
              );
            })}
          </div>

          <div
            style={{
              marginTop: 20,
              height: 300,
              overflow: "auto",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <FormGroup>
              <div style={{ display: "flex", flexDirection: "column" }}>
                {data &&
                  data?.fetchCompanies.data.map((reason) => (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={newValueCompany.includes(reason.id)}
                          value={reason.id}
                          onChange={handleChangeCheckbox}
                        />
                      }
                      label={reason.name}
                    />
                  ))}
              </div>
            </FormGroup>
          </div>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClearFilter} color="primary">
            Limpar
          </Button>
          <Button
            onClick={handleSelect}
            variant="contained"
            color="primary"
            disabled={loading}
          >
            Selecionar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
